module.exports = __webpack_public_path__ + "static/media/activationExcel.13b01162.gif";